import { useMutation, useQueryClient } from '@tanstack/react-query';

import type { ResponseModel, AnyObject } from 'common/interfaces';
import { useFetch } from 'hooks/use-fetch';

import { notificationQueryKeys } from '../query-keys';

export const useNotificationDeactivate = () => {
  const { fetch } = useFetch<ResponseModel<AnyObject>>({
    isShowLoading: false,
    isShowErrorSnackbar: true
  });
  const queryClient = useQueryClient();

  const deactivateNotifications = async (notificationIds: string[]) => {
    return fetch({
      requestConfig: {
        method: 'POST',
        url: '/Jobs/DeactivateMessages',
        data: {
          messageIds: notificationIds
        }
      }
    });
  };

  const { mutateAsync, ...rest } = useMutation({
    mutationFn: deactivateNotifications,

    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: notificationQueryKeys.lists() });
    }
  });

  return [mutateAsync, rest] as const;
};
